import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

const TermsOfService = () => {
  useEffect(() => {
    document.title = 'Terms of Service';

    return () => {
      document.title = 'GEO DEVELOPMENT'; 
    };
  }, []);

  return (
    <section style={{
      padding: '6rem 1.5rem 4rem',
      background: '#f8f9fa',
      minHeight: '100vh',
      color: '#2d3436',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start'
    }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        style={{
          width: '100%',
          maxWidth: '800px',
          background: 'white',
          padding: '3.5rem',
          borderRadius: '20px',
          border: '1px solid rgba(0, 0, 0, 0.08)',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.05)',
          position: 'relative'
        }}
      >
        <div style={{
          position: 'absolute',
          top: '20px',
          left: '20px',
          display: 'flex',
          gap: '8px',
        }}>
          <div style={{
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            background: '#ff6b6b',
          }}></div>
          <div style={{
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            background: '#ffa502',
          }}></div>
          <div style={{
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            background: '#2ecc71',
          }}></div>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '2.5rem'
        }}>
          <div>
            <Link 
              to="/"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                color: '#0072ff',
                textDecoration: 'none',
                fontSize: '0.95rem',
                fontWeight: '500',
                transition: 'color 0.2s ease',
                marginBottom: '1rem',
                ':hover': {
                  color: '#0056b3'
                }
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '0.5rem' }}>
                <path d="M19 12H5M12 19l-7-7 7-7"/>
              </svg>
              Back to Home
            </Link>

            <h1 style={{
              fontSize: '2.75rem',
              background: 'linear-gradient(90deg, #0072ff, #00c6ff)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: '700',
              marginBottom: '1rem',
              lineHeight: '1.2'
            }}>
              Terms of Service
            </h1>

            <p style={{ 
              color: '#666',
              fontSize: '0.95rem',
              marginBottom: '0'
            }}>
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>

          <div style={{ 
            color: '#4a4a4a', 
            lineHeight: 1.8,
            display: 'flex',
            flexDirection: 'column',
            gap: '2rem'
          }}>
            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                1. Introduction
              </h2>
              <p>
                Welcome to GEO DEVELOPMENT. By accessing or using our website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please refrain from using our services.
              </p>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                2. Services Description
              </h2>
              <p>
                GEO DEVELOPMENT provides web development, application design, and software consulting services. Our offerings may change over time and are subject to availability.
              </p>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                3. User Accounts
              </h2>
              <p>
                Some services may require you to create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
              </p>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                4. Intellectual Property
              </h2>
              <p>
                All content provided on our website, including but not limited to text, graphics, logos, and software, is the property of GEO DEVELOPMENT and is protected by intellectual property laws.
              </p>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                5. Limitation of Liability
              </h2>
              <p>
                GEO DEVELOPMENT shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use our services.
              </p>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                6. User Conduct
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                When using our services, you agree not to:
              </p>
              <ul style={{ 
                paddingLeft: '1.5rem',
                listStyleType: 'disc',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
              }}>
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe upon the rights of others</li>
                <li>Interfere with the operation of our services</li>
                <li>Attempt to gain unauthorized access to any part of our services</li>
              </ul>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                7. Termination
              </h2>
              <p>
                We reserve the right to terminate or suspend your account and access to our services at our discretion, without notice, for conduct that we believe violates these Terms of Service or is harmful to other users, us, or third parties.
              </p>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                8. Changes to Terms
              </h2>
              <p>
                We may modify these Terms of Service at any time. By continuing to use our services after such modifications, you agree to be bound by the updated terms.
              </p>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                9. Governing Law
              </h2>
              <p>
                These Terms of Service shall be governed by and construed in accordance with the laws of the jurisdiction in which GEO DEVELOPMENT operates, without regard to its conflict of law provisions.
              </p>
            </section>

            <section>
              <h2 style={{ 
                fontSize: '1.5rem', 
                color: '#2d3436',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                10. Contact Us
              </h2>
              <p>
                If you have any questions about these Terms of Service, please contact us at 
                <a href="mailto:geodevelopment21@gmail.com" style={{ 
                  color: '#0072ff', 
                  marginLeft: '5px', 
                  textDecoration: 'none',
                  fontWeight: '500',
                  transition: 'color 0.2s ease',
                  ':hover': {
                    color: '#0056b3'
                  }
                }}>
                  geodevelopment21@gmail.com
                </a>.
              </p>
            </section>
          </div>
        </div>
      </motion.div>
    </section>
  )
}

export default TermsOfService 